module.exports = __webpack_public_path__ + "static/media/deck-c.4ec7b56a.png";